export const QueryKeys = {
  CLIENTS: 'clients',
  DUPLICATE_CLIENTS: 'duplicate-clients',
  CLIENT_SALES_SUMMARY: 'client-sales-summary',
  SERVICES: 'services',
  TEAM_MEMBERS: 'team-members',
  APPOINTMENTS_GRID: 'appointments-grid',
  APPOINTMENT_SERVICES: 'appointment-services',
  CLIENT_VOUCHERS: 'client-vouchers',
  CLIENT_MEMBERSHIPS: 'client-memberships',
  VOUCHERS: 'vouchers',
  MEMBERSHIPS: 'memberships',
  PRODUCTS: 'products',
  SALES: 'sales',
  LOCATIONS: 'locations',
  IS_ADMIN: 'is-admin',
  USER: 'user',
  USERS: 'users',
  CURRENT_LOCATION: 'current-location',
  CURRENT_TEAM_MEMBER: 'current-team-member',
  SALES_APPOINTMENTS: 'sales-appointments',
  DAILY_SALE: 'daily-sale',
  PAYMENTS: 'payments',
  PRODUCT_SALES: 'product-sales',
  TIPS: 'tips',
  EMPLOYEE_SHIFTS: 'employee-shifts',
  PAYMENT_METHODS: 'payment-methods',
  VOUCHER_USAGE: 'voucher-usage',
  REPORTS: 'reports',
  SETTINGS: 'settings',
  TENANT: 'tenant',
  CATEGORIES: 'categories',
  TEAM_MEMBER_CATEGORIES: 'team-member-categories',
  STOCK_AUDIT: 'stock-audit-entries',
  STOCK_AUDIT_SESSIONS: 'stock-audit-sessions',
  CALENDAR_STAFF_DAY_EXCLUSIONS: 'calendar-staff-day-exclusions',
  CALENDAR_STAFF_EXCLUSION_RULES: 'calendar-staff-exclusion-rules',
  BLOCKED_TIMES: 'blocked-times',
  BLOCK_TIME_TYPES: 'block-time-types',
  BRANDS: 'brands',
  SUPPLIERS: 'suppliers',
  DASHBOARD_PERMISSIONS: 'dashboard-permissions',
  REPORTS_PERMISSIONS: 'reports-permissions',
  NAVIGATION_PERMISSIONS: 'navigation-permissions',
  TEAM_PERMISSIONS: 'team-permissions',
  BUNDLES: 'bundles',
  SUPPLIER_IMAGES: 'supplier-images',
  APPOINTMENT_STATUS_HISTORY: 'appointment-status-history',
  STOCK_INTAKE_HISTORY: 'stock-intake-history',
  STOCK_MOVEMENTS: 'stock-movements',
} as const;
